// Main API export file - re-exports all APIs for backward compatibility
import api from './client';

// Auth
export { authAPI } from './auth';

// Colleges
export { collegesAPI, compareAPI } from './colleges';

// Applications
export { 
  applicationsAPI, 
  recommendersAPI, 
  honorsAPI, 
  supplementalAPI, 
  additionalInfoAPI, 
  documentsAPI, 
  coursesAPI, 
  applicationVersionsAPI,
  reviewAPI,
  submissionAPI 
} from './applications';

// University Hub
export { universityAPI } from './university';

// Profile & User
export { profileAPI, notificationsAPI, decisionsAPI, parentLinkAPI } from './profile';

// Interview
export { interviewAPI } from './interview';

// Scores & Financial
export { scoresAPI, financialAPI } from './scores';

// Messages
export { messagesAPI } from './messages';

// Default export is the axios instance for custom calls
export default api;
